import {
  SET_PRE_HANDLE_LIST,
  SET_PRE_HANDLE_LIST_PAGE,
  SET_PRE_HANDLE_SORT,
  SET_PRE_HANDLE_LIST_QUERY,
  SET_PRE_HANDLE_LIST_PAGE_TOTAL,
  SET_PRE_HANDLE_LIST_PAGE_SIZE,
  SET_PRE_HANDLE_SEARCHING,
  RESET_PRE_HANDLE_LIST_QUERY,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  taskId: '',              // int是预处理id的字符串
  keywords: '',            // int-是（条件查询输入框里面的参数）作业id
  userName: '',            // String（条件查询输入框里面的参数）用户名
  userId: '',              // String（条件查询输入框里面的参数）用户id
  taskStatus: '',          // int-是（条件查询下拉框里面的参数）任务状态
  taskIdFlag: '',          // int-根据任务ID号进行排序,值为1为升序,值为0为降序,否则为空
  submitTimeFlag: '',      // int-根据提交时间排序,值为1为升序,值为0为降序,否则为空
  taskLevelFlag: '',       // int-根据作业等级排序,值为1为升序,值为0为降序,否则为空
  startTimeFlag: '',       // int-根据开始时间排序,值为1为升序,值为0为降序,否则为空
  completedTimeFlag: '',   // int-根据结束时间排序,值为1为升序,值为0为降序,否则为空
})
const state = {
  searching: false,
  initQuery: initQuery(),
  preHandle: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
    sort: {
      submitTimeFlag: 0,
    },
  },
  initPageSize: 50,
}

const mutations = {
  [SET_PRE_HANDLE_LIST] (state, payload) {
    state.preHandle.list = payload
  },
  [SET_PRE_HANDLE_SORT] (state, payload) {
    state.preHandle.sort = payload
  },
  [SET_PRE_HANDLE_LIST_PAGE] (state, payload) {
    state.preHandle.query.pageNum = payload
  },
  [SET_PRE_HANDLE_LIST_PAGE_TOTAL] (state, payload) {
    state.preHandle.listPageTotal = payload
  },
  [SET_PRE_HANDLE_LIST_PAGE_SIZE] (state, payload) {
    state.preHandle.query.pageSize = payload
  },
  [SET_PRE_HANDLE_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_PRE_HANDLE_LIST_QUERY] (state, payload) {
    state.preHandle.query = {
      ...state.preHandle.query,
      ...payload,
    }
  },
  [RESET_PRE_HANDLE_LIST_QUERY] (state, payload) {
    state.preHandle.query = payload
  },
}

const actions = {
  async getTaskPreSearchList ({commit, state, dispatch}, payload) {
    let query = {}
    _.forIn(state.preHandle.query, (v, k) => {
      if (k === 'keywords' || v !== '') {
        query[k] = v
      }
    })
    let params = {
      ...state.preHandle.sort,
      ...query,
      pageNum: state.preHandle.query.pageNum,
      pageSize: state.preHandle.query.pageSize,
      ...payload,
    }
    if (payload && !payload.userName && params.userName) {
      delete params.userName
    }
    commit(SET_PRE_HANDLE_SEARCHING, true)
    const {data, code} = await api.taskApi.getPreTaskList(params)
    checkUserName({
      code,
      data,
      callback: ({userId}) => {
        const { userName, ...other } = params
        dispatch('getTaskPreSearchList', {
          ...other,
          userId,
        })
      },
    })
    commit(SET_PRE_HANDLE_SEARCHING, false)
    data && data.items.map((itm) => {
      itm.taskFlag = 2
    })
    data && commit(SET_PRE_HANDLE_LIST, data.items)
    data && commit(SET_PRE_HANDLE_LIST_PAGE_TOTAL, data.total)
  },
  // 初始化列表
  async initPreHandleTaskList ({commit, dispatch, state}) {
    commit(SET_PRE_HANDLE_SORT, {submitTimeFlag: 0})
    commit(SET_PRE_HANDLE_LIST_PAGE_SIZE, state.initPageSize)
    commit(SET_PRE_HANDLE_LIST_PAGE, 1)
    dispatch('getTaskPreSearchList')
  },
  // 设置筛选条件
  setPreQuery ({commit}, payload) {
    commit(SET_PRE_HANDLE_LIST_QUERY, payload)
  },
  // 重置筛选条件
  resetPreQuery ({commit, state}) {
    commit(RESET_PRE_HANDLE_LIST_QUERY, state.initQuery)
  },
  async filterQuery ({commit, dispatch}, payload) {
    dispatch('setPreQuery', payload)
    await dispatch('getTaskPreSearchList')
  },
  async changePreHandleTaskListPage ({commit, dispatch}, payload) {
    commit(SET_PRE_HANDLE_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('getTaskPreSearchList')
  },
  changePageSize ({commit, dispatch}, {listPageSize}) {
    commit(SET_PRE_HANDLE_LIST_PAGE_SIZE, listPageSize)
    dispatch('changePreHandleTaskListPage', {currentPage: 1})
  },
  changePreHandleSort ({commit, dispatch}, payload) {
    commit(SET_PRE_HANDLE_SORT, payload)
    dispatch('changePreHandleTaskListPage', {currentPage: 1})
  },
  // 查看日志
  // eslint-disable-next-line
  async setPreHandleLogDetails ({}, {renderingType, render, munu, ...rest}) {
    if (renderingType === 'munuLog') {
      const {data} = await api.taskApi.getPerMunuLog({
        ...munu,
        ...rest,
      })
      return data
    } else {
      const {data} = await api.taskApi.getPreHandleLog({
        ...render,
        renderingType,
        ...rest,
      })
      return data
    }
  },
  // 清空黑名单
  async cleanPreBlackList ({commit}, payload) {
    const data = await api.taskApi.cleanPreBlackList(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
